import { Grid, Typography } from "@mui/material"

const VerificationSuccess = () => {
  return <Grid container sx={{minHeight: '300px'}}>
    <Grid item sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', textAlign: 'center'}}><Typography variant="h6">Thank you for verifying your order. We will be in touch with you shortly.</Typography></Grid>
  </Grid>
}

export default VerificationSuccess